import { Directive, TemplateRef, inject } from '@angular/core';

/** Context passed to the projected [gridDetail] panel template. */
export interface GridDetailContext<T = unknown> {
  /** The selected row (also `let-row`). */
  $implicit: T;
  row: T;
}

/**
 * Declares the slide-in detail-panel content. A single template per grid; the
 * grid projects it with the selected row as context:
 *
 *   <ng-template gridDetail let-row> … </ng-template>
 */
@Directive({
  selector: 'ng-template[gridDetail]',
})
export class GridDetailDirective<T = unknown> {
  readonly template = inject<TemplateRef<GridDetailContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(
    _dir: GridDetailDirective<T>,
    _ctx: unknown,
  ): _ctx is GridDetailContext<T> {
    return true;
  }
}
